module.exports = __webpack_public_path__ + "static/media/icon_mg05s.7a5a5d0a.svg";